import { createContext } from "react";

const initialValue = {
  categories: [],
  user: {
    name: "",
    role: "",
    email: "",
    auth_token: "",
    domain: "",
    phone_number: "",
  },
};

export const admin_Context = createContext(initialValue);

admin_Context.displayName = "Admin Context";
